import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery} from "../../utils/api-config";
import {CityDTO} from "../../types/organization/CityDTO";
import {Response} from "../../types/response/Response";
import {BranchDTO} from "../../types/organization/BranchDTO";

export const organizationApi = createApi({
    reducerPath: "organization",
    baseQuery: apiQuery,
    tagTypes: ["branches", "cities"],
    endpoints: builder => ({
        getCities: builder.query<Response<CityDTO[]>, void>({
            query: () => '/cities',
            providesTags: ['cities']
        }),
        getBranches: builder.query<Response<BranchDTO[]>, void>({
            query: () => '/branches',
            providesTags: ['branches']
        }),

        synchronize: builder.mutation<void, void>({
            query: () => ({
                url: '/branches/sync',
                method: "POST"
            }),
            invalidatesTags: ["branches", "cities"]
        })
    })
})

export const {useSynchronizeMutation, useGetBranchesQuery, useGetCitiesQuery} = organizationApi
